module.exports = __webpack_public_path__ + "img/title_5.2c588788.png";